import React, { Component } from 'react';
import { DatePicker, Button, Input, Select, Table, Popconfirm, Modal, AutoComplete, Icon, message, Card } from 'antd';
import { Redirect } from 'react-router';
import moment from 'moment';
import './style.less';
import utils from '../../../utils/common';
import AdditionBrand from './addbrand';

const Option = Select.Option;
class BrandList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brandName: '', // 搜索的品牌名称
      startTime: '', // 开始时间
      endTime: '', // 结束时间
      brandStatus: '', // 品牌启用状态
      brandsList: [], //品牌数据名称
      isLoading: false,
      currentPage: 1, // 当前页
      pagination: { // 页码信息
        page_size: 10,
        current: 1, // 当前页
        total: null, // 数据总数
        onChange: this.changePage
      },
      editInfo: { // 编辑信息
        name: null, // 品牌名
        selfId: '', // 品牌id,
        editStatus: null, // 品牌状态
      },
      isAdd: 0, //是添加还是编辑 0 新增 1 编辑
      addvisible: false, // model是否显示
      brandNameData: [],
      redirect: false, // 登录信息是否过期重定向到登录页
    };
  }

  componentWillMount() {
    this.getBrandList(1);
  }

  // 获取品牌列表
  getBrandList = (currentPage) => {
    const {
      brandName, startTime, endTime, brandStatus
    } = this.state;
    if (startTime && endTime && new Date(endTime).getTime() < new Date(startTime).getTime()) {
      message.error('结束时间不得大于开始时间');
      return;
    }
    let params = {
      page_size: 10,
      brand_name: brandName,
      start_time: startTime,
      end_time: endTime,
      brand_status: brandStatus,
      current_page: currentPage
    };
    params = utils.dealElement(params); // 去除空项
    window.api('eps.getgoodsbrand', params).then(res => {
      const pagination = {
        page_size: 10,
        current: Number(currentPage),
        total: Number(res.total_result),
        onChange: this.changePage
      };
      this.setState({brandsList: res.goods_brand_list, pagination, currentPage});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 改变页码
  changePage = (page) => {
    this.getBrandList(page);
  }

  // 绑定数据
  bindValue = (type, value1, value2) => {
    if (type === 'startTime' || type === 'endTime') {
      this.setState({ [type]: value2 });
    } else {
      this.setState({ [type]: value1 });
    }
  }

  resetFilter = () => {
    this.setState(
      { brandName: '', startTime: '', endTime: '', brandStatus: '' },
      () => this.getBrandList(1)
    );
  }

  // 打开新增品牌弹框
  operationDialog = (type) => {
    const addvisible = type === 'open' ? Boolean(1) : Boolean(0);
    const editInfo = {name: '', editStatus: '1', selfId: null};
    this.setState({addvisible, isAdd: 0, editInfo});
    type === 'operation' ? this.getBrandList(this.state.currentPage) : null;
  }

  // 打开编辑品牌弹框
  edit = (item) => {
    const editInfo = {name: item.brand_name, editStatus: item.brand_status, selfId: item.id};
    this.setState({addvisible: true, isAdd: 1, editInfo});
  }

  // 品牌的删除或变更
  changeStatus = (type, id) => {
    const params = {id};
    let status = null;
    let tip = null;
    switch (type) {
      case 'start':
        status = 1;
        tip = '已启用';
        break;
      case 'stop':
        status = 2;
        tip = '已停用';
        break;
      case 'delete':
        status = 3;
        tip = '删除成功';
        break;
      default:
        null;
    }
    params.brand_status = status;
    window.api('eps.modgoodsbrand', params).then(() => {
      message.success(tip);
      this.getBrandList(this.state.currentPage);
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 搜索框下拉列表
  renderOption(item) {
    return (
      <Option key={item.name} text={item.name}>
        {item.name}
      </Option>
    );
  }

  render() {
    if (this.state.redirect) return (<Redirect to="/login" />);
    const {
      isAdd, editInfo, addvisible, brandsList, pagination, brandStatus, brandNameData, isLoading
    } = this.state;
    const columns = [
      {
        title: '品牌名称',
        key: 'brand_name',
        dataIndex: 'brand_name'
      },
      {
        title: '创建时间',
        key: 'gmt_created',
        dataIndex: 'gmt_created',
        width: 250,
      },
      {
        title: '品牌状态',
        key: 'brand_status',
        dataIndex: 'brand_status',
        width: 200,
        render: (status) => (status === '1' ? <span className="brand-status brand-status--on">启用</span> : <span className="brand-status brand-status--off">禁用</span>),
      },
      {
        title: '操作',
        key: 'operation',
        width: 250,
        render: (_, record) => (
          <div className="brand-list-actions">
            <Button type="link" size="small" onClick={() => this.edit(record)}>编辑</Button>
            <Popconfirm title="是否要停用此品牌？" onConfirm={() => this.changeStatus(record.brand_status === '1' ? 'stop' : 'start', record.id)} okText="确定" cancelText="取消">
              <Button type="link" size="small">{record.brand_status === '1' ? '停用' : '启用'}</Button>
            </Popconfirm>
            <Popconfirm title="是否要删除此品牌？" onConfirm={() => this.changeStatus('delete', record.id)} okText="确定" cancelText="取消">
              <Button type="link" size="small">删除</Button>
            </Popconfirm>
          </div>
        ),
      },
    ];
    return (
      <div className="brank-blocks brand-list-page">
        {addvisible && (
          <Modal
            title={isAdd ? '编辑品牌' : '新增品牌'}
            visible={addvisible}
            onCancel={() => this.operationDialog('cancel')}
            footer={null}
            width={480}
            className="brand-edit-modal"
          >
            <AdditionBrand
              isAdd={isAdd}
              editInfo={editInfo}
              onClick={() => this.operationDialog('cancel')}
              addtionBrandEvent={() => this.operationDialog('operation')}
            />
          </Modal>
        )}
        <div className="brand-list-header">
          <h2 className="brand-list-title">品牌管理</h2>
          <Button type="primary" icon="plus" onClick={() => this.operationDialog('open')} className="brand-list-add-btn">新增品牌</Button>
        </div>
        <Card className="brand-list-filter" bordered={false}>
          <div className="brand-list-filter__row">
            <div className="brand-list-filter__item">
              <span className="brand-list-filter__label">品牌名称：</span>
              <AutoComplete
                className="brand-list-filter__input"
                dropdownMatchSelectWidth={false}
                dataSource={brandNameData.map(this.renderOption)}
                placeholder="请输入品牌名称"
                optionLabelProp="text"
                value={this.state.brandName}
                onBlur={(e) => e.target && this.bindValue('brandName', e.target.value)}
                onChange={(v) => this.bindValue('brandName', v)}
              >
                <Input suffix={<Icon type="search" />} allowClear />
              </AutoComplete>
            </div>
            <div className="brand-list-filter__item">
              <span className="brand-list-filter__label">品牌状态：</span>
              <Select
                placeholder="全部"
                value={brandStatus === '' ? undefined : brandStatus}
                onChange={(v) => this.bindValue('brandStatus', v)}
                className="brand-list-filter__select"
              >
                <Option value="">全部</Option>
                <Option value="1">启用</Option>
                <Option value="2">禁用</Option>
              </Select>
            </div>
            <div className="brand-list-filter__item">
              <span className="brand-list-filter__label">开始日期：</span>
              <DatePicker format="YYYY-MM-DD" value={this.state.startTime ? moment(this.state.startTime, 'YYYY-MM-DD') : null} onChange={(date, dateStr) => this.bindValue('startTime', null, dateStr)} className="brand-list-filter__input" style={{ width: '100%' }} />
            </div>
            <div className="brand-list-filter__item">
              <span className="brand-list-filter__label">结束日期：</span>
              <DatePicker format="YYYY-MM-DD" value={this.state.endTime ? moment(this.state.endTime, 'YYYY-MM-DD') : null} onChange={(date, dateStr) => this.bindValue('endTime', null, dateStr)} className="brand-list-filter__input" style={{ width: '100%' }} />
            </div>
            <div className="brand-list-filter__actions">
              <Button type="primary" icon="search" onClick={() => this.getBrandList(1)}>查询</Button>
              <Button onClick={this.resetFilter}>重置</Button>
            </div>
          </div>
        </Card>
        <Card className="brand-list-table-card" bordered={false}>
          <Table
            columns={columns}
            dataSource={brandsList}
            pagination={{ ...pagination, showSizeChanger: true, showTotal: (total) => `共 ${total} 条` }}
            className="brand-list-table"
            rowKey={(record) => record.id}
            loading={isLoading}
            scroll={{ x: 1000 }}
          />
        </Card>
      </div>
    );
  }
}
export default BrandList;



// WEBPACK FOOTER //
// ./src/containers/backEnd/brandMangement/brandlist.jsx